﻿import { useContext, useEffect, useState } from "react";
import {UserContext, UserState} from "../contexts/UserContext";

export function useUser(): UserState {
	const store = useContext(UserContext);
	if (!store) {
		throw new Error('useUser must be used within UserState');
	}

	const [selectedState, setSelectedState] = useState(store.getState());

	useEffect(() => {
		return store.subscribe(() => {
			setSelectedState(store.getState());
		});

	}, [store]);

	return selectedState;
}
